(function(config) {
    'use strict';

    angular.module('competence.services', [
            'ngResource',
        ])
        .factory('competenceDataSrvc', competenceDataSrvc)
        .factory('competenceSrvc', competenceSrvc);

    competenceDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function competenceDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/competencies/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            adminList: {
                method: 'GET',
                url: config.api + '/api/v1/competencies/admin_list/',
                isArray: true
            },
            clientContactList: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/competencies/client_contact_list/',
            }
        });
    }

    competenceSrvc.$inject = ['competenceDataSrvc', 'modalSrvc'];

    function competenceSrvc(competenceDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    competenceDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

})(window.config);
